// BrandingSection.jsx
import React from 'react';
import { Form, Input, Upload, Typography, Button} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import container from "container/BrokerDashboard/editAgentContainer"

const { Title } = Typography;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  
  &:hover {
    color: #1890ff;
  }
`;

const EditButton = styled(Button)`
  color: white !important;
  border-color: #6366F1 !important;
  background: #6366F1 !important;
  border-radius: 8px !important;
  font-weight: 500;
  height: 36px !important;
  padding: 0 16px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  
  &:hover {
    color: white !important;
    border-color: #6366F1 !important;
    background: #6366F1 !important;
  }
  
  &:focus {
    color: white !important;
    border-color: #6366F1 !important;
    background: #6366F1 !important;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
`;

const BrandingSection = (props) => {
  const handleTitleClick = () => {
    window.location.href = '/client-app-branding';
  };

  const handleEditClick = () => {

    const agentName = props?.agentName || props?.agent?.name || '';
    const agentEmail = props?.agentEmail || props?.agent?.email || '';
    
    const searchParams = new URLSearchParams();
    if (agentName) {
      searchParams.append('search', agentName);
    }
    if (agentEmail) {
      searchParams.append('email', agentEmail);
    }
    
    const url = `/broker/consumer-app${searchParams.toString() ? '?' + searchParams.toString() : ''}`;
    window.location.href = url;
  };

  return (
    <div>
      <Header>
        <HeaderContent>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.75 9.75C6.75 9.33579 7.08579 9 7.5 9H16.5C16.9142 9 17.25 9.33579 17.25 9.75C17.25 10.1642 16.9142 10.5 16.5 10.5H7.5C7.08579 10.5 6.75 10.1642 6.75 9.75ZM7.5 13.5H16.5C16.9142 13.5 17.25 13.1642 17.25 12.75C17.25 12.3358 16.9142 12 16.5 12H7.5C7.08579 12 6.75 12.3358 6.75 12.75C6.75 13.1642 7.08579 13.5 7.5 13.5ZM21.75 5.25V19.5C21.7499 19.7599 21.6152 20.0012 21.394 20.1378C21.1729 20.2743 20.8968 20.2866 20.6644 20.1703L18 18.8381L15.3356 20.1703C15.1244 20.276 14.8756 20.276 14.6644 20.1703L12 18.8381L9.33562 20.1703C9.12436 20.276 8.87564 20.276 8.66438 20.1703L6 18.8381L3.33562 20.1703C3.1032 20.2866 2.82712 20.2743 2.60597 20.1378C2.38483 20.0012 2.25014 19.7599 2.25 19.5V5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H20.25C21.0784 3.75 21.75 4.42157 21.75 5.25ZM20.25 5.25H3.75V18.2869L5.66437 17.3288C5.87564 17.223 6.12436 17.223 6.33563 17.3288L9 18.6619L11.6644 17.3288C11.8756 17.223 12.1244 17.223 12.3356 17.3288L15 18.6619L17.6644 17.3288C17.8756 17.223 18.1244 17.223 18.3356 17.3288L20.25 18.2869V5.25Z"
              fill="#111827"
            />
          </svg>
          <SectionTitle onClick={handleTitleClick}>Client App Branding</SectionTitle>
        </HeaderContent>
        <EditButton
          type="default"
          onClick={handleEditClick}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.41421 3.25253C6.19526 4.03358 6.19526 5.29991 5.41421 6.08096C4.63316 6.86201 3.36683 6.86201 2.58579 6.08096C1.80474 5.29991 1.80474 4.03358 2.58579 3.25253C3.36683 2.47149 4.63316 2.47149 5.41421 3.25253" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.3333 4.66659H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.4142 9.91904C14.1953 10.7001 14.1953 11.9664 13.4142 12.7475C12.6332 13.5285 11.3668 13.5285 10.5858 12.7475C9.80474 11.9664 9.80474 10.7001 10.5858 9.91904C11.3668 9.13799 12.6332 9.13799 13.4142 9.91904" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.6665 11.3333H9.99984" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Edit
        </EditButton>
      </Header>
      
    
    </div>
  );
};

export default container(BrandingSection);